import { render, staticRenderFns } from "./OnHoldItem.vue?vue&type=template&id=7f02b61a&scoped=true"
import script from "./OnHoldItem.vue?vue&type=script&lang=js"
export * from "./OnHoldItem.vue?vue&type=script&lang=js"
import style0 from "./OnHoldItem.vue?vue&type=style&index=0&id=7f02b61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f02b61a",
  null
  
)

export default component.exports